export default "__VITE_ASSET__c6666b27__"